import { Map, List, fromJS } from 'immutable';
// Enhanced version that handles all the required structure for react-awesome-query-builder
function convertToImmutableTreeComplete(node) {
    if (!node) return null;

    // Use fromJS but then ensure proper structure
    let immutableNode = fromJS(node);

    // Ensure path is a List
    if (node.path) {
        immutableNode = immutableNode.set('path', List(node.path));
    }

    // For rule nodes, ensure properties is properly structured
    if (node.type === 'rule') {
        if (!immutableNode.has('properties')) {
            immutableNode = immutableNode.set('properties', Map());
        } else {
            // Ensure properties is an Immutable Map
            const props = immutableNode.get('properties');
            if (!Map.isMap(props)) {
                immutableNode = immutableNode.set('properties', Map(props));
            }
        }
    }

    if (immutableNode.has('children1')) {
        const children = immutableNode.get('children1');
    
        if (List.isList(children)) {
            const processedChildren = children.map((child: any) =>
                convertToImmutableTreeComplete(child.toJS ? child.toJS() : child)
            );
            immutableNode = immutableNode.set('children1', processedChildren);
        } else if (Map.isMap(children)) {
            // If children1 is a Map instead of List, handle accordingly
            const processedChildren = children.map((child: any) =>
                convertToImmutableTreeComplete(child.toJS ? child.toJS() : child)
            );
            immutableNode = immutableNode.set('children1', processedChildren);
        }
    }
    
    return immutableNode;
}

export default convertToImmutableTreeComplete;